import React, { Component } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList,
} from 'recharts';

import { colors } from './common';

// function flattenStats(stats, xFamilyKeys, xKeys) {
//   return stats.map(tagStats => xFamilyKeys.reduce((agg, xFamilyKey) => (
//     {
//       ...agg,
//       ...(xKeys.reduce((agg, xKey) => (
//         {
//           ...agg,
//           [`${xFamilyKey}_${xKey}`]: tagStats[xFamilyKey][xKey],
//         }
//       ), {}))
//     }
//   ), {
//     ...tagStats
//   }));
// }

export const Chart = ({ stats, xKeys, xFamilyKeys }) => (
  <div style={{ margin: '30px 0' }}>
    <BarChart width={760} height={300} data={stats}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="tag" />
      <YAxis />
      <Tooltip />
      <Legend />
      {
        xFamilyKeys.map((xFamilyKey, i) => (
          xKeys.map((xKey, j) => (
            <Bar 
              key={`${i}-${j}`}
              // type="monotone"
              fill={colors[j]}
              dataKey={`${xFamilyKey}.${xKey}`}
              stackId={xFamilyKey}
              activeDot={{ r: 8 }}
              label={{ fill: 'black', fontSize: 16, }}//position: ['center', 'left', 'hidden', 'center', ][j] }}
            />
          ))
        ))
      }
    </BarChart>
  </div>
);